import React, { Component } from 'react';
import EntryTable from './entryTable.js';

class Home extends Component {

  render() {
    return (
      <div>
          <EntryTable id="maintable" ref={this.mytable} />
      </div>
      
    );
  }
}

export default Home;
